import { FC, useEffect } from "react";
import { ENABLE_TRACKING_SCRIPTS } from "~features/tracking/config";

interface MarketingGTMScriptProps {
  containerId?: string;
}

export const GoogleTagManagerScript: FC<MarketingGTMScriptProps> = ({
  containerId,
}) => {
  useEffect(() => {
    if (ENABLE_TRACKING_SCRIPTS && !!containerId) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        const f = d.getElementsByTagName(s)[0],
          j: any = d.createElement(s),
          dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.defer = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", containerId);
    }
  }, [containerId]);

  return null;
};
